export const SET_IS_LOADING = 'OPEN_API/SET_IS_LOADING';
export const SET_BUSINESS_UUID = 'OPEN_API/SET_BUSINESS_UUID';
export const SET_TOKENS = 'OPEN_API/SET_TOKENS';
export const CLEAR_TOKEN = 'OPEN_API/CLEAR_TOKEN';